var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tile", { attrs: { link: "ved" } }, [
    _c(
      "div",
      { attrs: { slot: "tileHeader" }, slot: "tileHeader" },
      [
        _c("tile-title", { attrs: { icon: "globe" } }, [
          _vm._v("Внешнеэкономическая деятельность"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.years.length
      ? _c(
          "div",
          {
            staticClass: "ved",
            attrs: { slot: "tileContent" },
            slot: "tileContent",
          },
          [
            _c("div", { ref: "vedHtml" }, [
              _c("table", { staticClass: "ved__table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "first-column" }),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v("Контракто-"),
                      _c("br"),
                      _vm._v("держатель"),
                    ]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Декларант")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Получатель")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Отправитель")]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.years, function (e, i) {
                    return _c("tr", { key: i }, [
                      _c("td", { staticClass: "first-column" }, [
                        _vm._v(_vm._s(e)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.auth
                            ? _c("checkOrTimes", {
                                attrs: { isCheck: _vm.data[e].holder },
                              })
                            : _c("span", [_vm._v("░░")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.auth
                            ? _c("checkOrTimes", {
                                attrs: { isCheck: _vm.data[e].declarant },
                              })
                            : _c("span", [_vm._v("░░")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.auth
                            ? _c("checkOrTimes", {
                                attrs: { isCheck: _vm.data[e].receiver },
                              })
                            : _c("span", [_vm._v("░░")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.auth
                            ? _c("checkOrTimes", {
                                attrs: { isCheck: _vm.data[e].sender },
                              })
                            : _c("span", [_vm._v("░░")]),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ved__footer",
        attrs: { slot: "tileFooter" },
        slot: "tileFooter",
      },
      [
        _c("tilePrintPdf", {
          attrs: {
            html: _vm.htmlForPrint,
            title: _vm.title,
            filename: _vm.filename,
            printStyle: _vm.printStyle,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }